import { render } from "./GestionUsuarios.vue?vue&type=template&id=0de63a92&scoped=true"
import script from "./GestionUsuarios.vue?vue&type=script&lang=js"
export * from "./GestionUsuarios.vue?vue&type=script&lang=js"

import "./GestionUsuarios.vue?vue&type=style&index=0&id=0de63a92&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0de63a92"

export default script